import Button from '@asphalt-react/button';
import Flag from '@asphalt-react/flag';
import { Search } from '@asphalt-react/textfield';
import cn from 'classnames';
import firebase from 'firebase/app';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { Image, Shimmer } from 'react-shimmer';
import Permission from '../../authorization/components/Permission';
import actions from '../../authorization/models/actions';
import ConfigProvider from '../../common/components/ConfigProvider';
import configKeys from '../../common/models/config-keys';
import routes from '../../common/models/route-constants';
import NoSearchResultsFound from '../../common/components/NoSearchResultsFound';
import styles from './TileLogoHomePage.module.css';

function TileLogoHomePage() {
    let { path } = useRouteMatch();
    let history = useHistory();
    const location = useLocation();
    const [tileLogo, setTileLogos] = useState([]);
    const [notification, setNotification] = useState(null);
    const [filteredTileLogos, setFilteredTileLogos] = useState([]);
    const [filterString, setFilterString] = useState('');

    const clearHistoryNotificationState = (history) => {
        let state = { ...history.location.state };
        delete state.notification;
        history.replace({
            ...history.location,
            state,
        });
    };

    const filter = _.debounce((term) => {
        setFilterString(term);
        filterList(term);
    }, 300);

    const filterList = (inputFilterString) => {
        if (_.isEmpty(inputFilterString)) {
            setFilteredTileLogos(tileLogo);
            return;
        }
        // constructing the regex string for case-insensitive matching
        var regex = new RegExp(_.escapeRegExp(inputFilterString), 'i');

        setFilteredTileLogos(
            _.filter(tileLogo, (tileLogoItem) => {
                return tileLogoItem.data().combined_name.match(regex);
            })
        );
    };

    useEffect(() => {
        if (location.state && location['state'].notification) {
            setNotification(location.state.notification);
        }

        // set listener
        var db = firebase.firestore();
        const unsubscribeGetAllTileLogosListener = db
            .collection('tile_logo')
            .orderBy('created_at', 'desc')
            .onSnapshot(
                function (snapshot) {
                    setTileLogos(snapshot.docs);
                    if (_.isEmpty(filterString)) {
                        setFilteredTileLogos(snapshot.docs);
                    }
                },
                function (error) {
                    throw error;
                }
            );
        return () => {
            unsubscribeGetAllTileLogosListener();
        };
    }, [history, location, filterString]);

    function getTileLogoImageView(doc) {
        if ('loading' in HTMLImageElement.prototype) {
            // Browser supports `loading` atttribute
            // Use img tag with loading attribute set as lazy to support lazy loading
            // TODO: Use Image component here along with loading attribute
            return (
                <img
                    loading='lazy'
                    src={doc.data().img_url}
                    className={styles.image}
                    alt={doc.data().combined_name}
                />
            );
        } else {
            // Browser doesn't support `loading` attribute
            // Use Image component from react-shimmer to show shimmer while image is loading
            return (
                <Image
                    src={doc.data().img_url}
                    className={styles.image}
                    fallback={<Shimmer width={360} height={240} />}
                    NativeImgProps={{ alt: doc.data().combined_name }}
                />
            );
        }
    }

    function getTileLogoItem(doc) {
        return (
            <Link
                to={`${path}/${doc.id}`}
                key={doc.data().combined_name}
                className={styles.iconCard}>
                <p className={styles.tileLogoName}>
                    {doc.data().combined_name}
                </p>
                <div className={styles.imageContainer}>
                    {getTileLogoImageView(doc)}
                </div>
            </Link>
        );
    }
    return (
        <div style={{ width: '100%' }}>
            <div className={cn('panel', { show: notification })}>
                <div className={cn('animateFlag', { visible: notification })}>
                    <Flag
                        success
                        floating
                        title={notification ? notification.title : ''}
                        content={notification ? notification.content : ''}
                        actionable
                        engageCaption={notification ? notification.ctaText : ''}
                        engageProps={{
                            onClick: () => {
                                if (notification) {
                                    setNotification(null);
                                    clearHistoryNotificationState(history);
                                    history.push(
                                        `${path}/${notification.tileLogoId}`
                                    );
                                }
                            },
                        }}
                        onDismiss={() => {
                            setNotification(null);
                            clearHistoryNotificationState(history);
                        }}
                    />
                </div>
            </div>
            <div className={styles.homePageContainer}>
                <div className={cn(styles.topBarContainer, 'shadowLow')}>
                    <div className={styles.topBar}>
                        <div className={styles.headerContainer}>
                            <h3 className={styles.heading}>Tile Logo</h3>
                            <div className={styles.buttonContainer}>
                                <ConfigProvider
                                    configKey={
                                        configKeys.IS_CREATE_ICON_ENABLED
                                    }>
                                    <Permission action={actions.CREATE_ICON}>
                                        <Button
                                            onClick={() => {
                                                history.push(
                                                    `${path}/${routes.CREATE}`
                                                );
                                            }}>
                                            Add Tile Logo
                                        </Button>
                                    </Permission>
                                </ConfigProvider>
                            </div>
                        </div>
                        <Search
                            onChange={(e) => {
                                filter(e.target.value);
                            }}
                            size='m'
                            placeholder='Search for tile logo by key or name'
                            stretch
                        />
                    </div>
                </div>
                <div className={styles.gridContainer}>
                    {filteredTileLogos.length > 0 ? (
                        <div className={styles.grid}>
                            {filteredTileLogos.map((doc) =>
                                getTileLogoItem(doc)
                            )}
                        </div>
                    ) : !_.isEmpty(filterString) ? (
                        <NoSearchResultsFound searchQuery={filterString} />
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export default TileLogoHomePage;
